import React, { useEffect, useMemo, useState, useCallback, useRef } from "react";
import _ from "lodash";
// @material-ui/core components
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import moment from "moment";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import AddIcon from "@material-ui/icons/Add";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import OrderView from "../Order/OrderView.js";
import PrescriptionOrderAdd from "../Order/PrescriptionOrderAdd.js";
import axios from "axios";
import {
  baseUrl,
  BulkPrintOrdersAPI,
  DeleteOrderAPI,
  GetAllOrdersAPI,
  UpdateMultipleOrders,
  UpdateOrderAPI,
} from "../../config/api";
import { ConfirmationDialog } from "../../components/common";
import CustomTabs from "../../components/CustomTabs/CustomTabs";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
import Checkbox from "@material-ui/core/Checkbox";
import { useHistory } from "react-router-dom";
import CustomInput from "../../components/CustomInput/CustomInput";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import SendEmail from "../Order/SendEmail.js";
import { OrderDetailsDialog } from "../OrderApp/OrderDetailsDialog.js";
import { fxOrderTemplate } from "../../assets/html/readyOrderTemplate.js";
import {
  dataURItoBlob,
  htmlTemplateToDataString,
  sendWhatsAppMessage,
} from "../../utils/index.js";
import PrintIcon from "@mui/icons-material/Print";
import { Search } from "@material-ui/icons";
import SendWhatsApp from "../Order/sendWhatsApp.js";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
}));

const columns = [
  { id: "party", label: "Party" },
  { id: "code", label: "Order Code" },
  { id: "orderType", label: "Order Type" },
  { id: "product", label: "Product" },
  { id: "productType", label: "Product Type" },
  {
    id: "orderAmount",
    label: "Order Amount",
    format: (value) =>
      Number(value).toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      }),
  },
  {
    id: "createdAt",
    label: "Order Date",
    format: (value) => (value ? moment(value).format("DD-MM-YYYY") : ""),
  },
  { id: "action", label: "Action" },
];

const orderTypes = ["Fitting", "Prescription"];

// Define tab configurations with their specific filters (outside component to avoid recreation)
const tabConfigs = [
  {
    key: 'pendingWeb',
    filters: { orderStatus: 'Pending', isOrderFromApp: false },
    label: 'Pending Web'
  },
  {
    key: 'completedWeb',
    filters: { orderStatus: 'Completed', isOrderFromApp: false },
    label: 'Completed Web'
  },
  {
    key: 'pendingApp',
    filters: { orderAdminStatus: 'Pending', isOrderFromApp: true },
    label: 'Pending App'
  },
  {
    key: 'completedApp',
    filters: { orderAdminStatus: 'Confirmed', isOrderFromApp: true },
    label: 'Completed App'
  }
];

export default function PrescriptionList(props) {
  const classes = useStyles();
  const history = useHistory();
  let userInfo = useSelector((state) => state.userReducer.userInfo);
  let authToken = useSelector((state) => state.userReducer.authToken);
  const [orders, setOrders] = useState([]);
  const [ordersGrouped, setOrdersGrouped] = useState([]);
  const [openReadyOrderAddDialog, setOpenReadyOrderAddDialog] = useState(false);
  const [openPrescriptionOrderAddDialog, setOpenPrescriptionOrderAddDialog] =
    useState(false);
  const [openFittingOrderAddDialog, setOpenFittingOrderAddDialog] =
    useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRows1, setSelectedRows1] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [openViewDialog, setOpenViewDialog] = useState(null);
  const [openOrderTypeDialog, setOpenOrderTypeDialog] = useState(false);
  const [selectedType, setSelectedType] = useState(orderTypes[0]);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [search, setSearch] = useState("");
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [openWhatsappDialog, setOpenWhatsappDialog] = useState(false);
  const [openOrderDetailsModal, setOpenOrderDetailsModal] = useState(null);
  const [orderAdminDetails, setOrderAdminDetails] = useState(null);
  const [tota, setTota] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const _getOrders = useCallback(
    async (page, rowsPerPage, searchTerm = "", tabFilters = null) => {
      setLoading(true);

      // Fix NaN comparison bug
      if (
        rowsPerPage === undefined ||
        rowsPerPage === null ||
        Number.isNaN(rowsPerPage)
      ) {
        rowsPerPage = 10;
      }

      if (page === undefined || page === null || Number.isNaN(page)) {
        page = 0;
      }

      // Use provided filters or current tab's filters
      const currentTab = tabConfigs[activeTabIndex];
      const filters = tabFilters || (currentTab ? currentTab.filters : {});

      try {
        let query = `&sortBy=createdAt:desc&limit=${rowsPerPage}&skip=${page * rowsPerPage}&orderType=Prescription`;

        // Add tab-specific filters
        if (filters.orderStatus) {
          query += `&orderStatus=${filters.orderStatus}`;
        }
        if (filters.orderAdminStatus) {
          query += `&orderAdminStatus=${filters.orderAdminStatus}`;
        }
        if (filters.isOrderFromApp !== undefined) {
          query += `&isOrderFromApp=${filters.isOrderFromApp}`;
        }

        if (searchTerm) {
          query += `&code=${searchTerm}`;
        }

        let res = await axios.get(GetAllOrdersAPI(userInfo.entity) + query, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        setOrders(res.data.orders);
        setOrdersGrouped(res.data.ordersGrouped);
        setTota(res.data.total);
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.error("Error fetching orders:", err);
        }
        toast.error("Failed to fetch orders. Please try again.", {
          position: "top-center",
          autoClose: 3000,
          theme: "light",
        });
      } finally {
        setLoading(false);
      }
    },
    [userInfo.entity, authToken, activeTabIndex]
  );

  // Refresh orders function - wrapper for _getOrders with current state
  const refreshOrders = useCallback(() => {
    _getOrders(page, rowsPerPage, searchTerm);
  }, [page, rowsPerPage, searchTerm, _getOrders]);

  // Search data function (defined after _getOrders since it depends on it)
  const searchData = useCallback(async (term) => {
    setSearchTerm(term);
    setPage(0);
    await _getOrders(0, rowsPerPage, term);
  }, [rowsPerPage, _getOrders]);

  // Debounced search function (defined after _getOrders since it depends on it)
  const debouncedSearchRef = useRef(
    _.debounce((term, currentRowsPerPage, getOrdersFn) => {
      if (term && term.trim()) {
        setSearchTerm(term.trim());
        setPage(0);
        getOrdersFn(0, currentRowsPerPage, term.trim());
      } else {
        setSearchTerm("");
        setPage(0);
        getOrdersFn(0, currentRowsPerPage, "");
      }
    }, 300)
  );

  // Cleanup debounced function on unmount
  useEffect(() => {
    return () => {
      debouncedSearchRef.current.cancel();
    };
  }, []);

  // Fetch orders when page, rowsPerPage, or activeTabIndex changes
  useEffect(() => {
    _getOrders(page, rowsPerPage, searchTerm);
  }, [page, rowsPerPage, activeTabIndex, _getOrders, searchTerm]);

  // Handle tab change
  const handleTabChange = useCallback((event, newValue) => {
    setActiveTabIndex(newValue);
    setPage(0); // Reset to first page when tab changes
    setSearchTerm(""); // Clear search when tab changes
  }, []);

  const _deleteItem = useCallback(async (item) => {
    try {
      await axios.delete(DeleteOrderAPI(item._id), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      toast.success("Successfully Deleted!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      _getOrders(page, rowsPerPage, searchTerm);
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error deleting order:", e);
      }
      toast.error("Failed to delete order. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }, [authToken, _getOrders, page, rowsPerPage, searchTerm]);

  const _onPrintAllOrders = useCallback(async () => {
    try {
      await axios.post(
        BulkPrintOrdersAPI(),
        {
          orders: selectedRows,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      // Optimize array operations with Map-based lookup
      const ordersMap = new Map(orders.map(o => [o._id, o]));
      const tmp = selectedRows.map((id) => {
        const o = { ...ordersMap.get(id) };
        if (o) {
          o.printCustomerName = false;
        }
        return o;
      }).filter(Boolean);

      history.push("/admin/order-print", { orders: tmp });
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error printing orders:", e);
      }
      toast.error("Failed to print orders. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }, [selectedRows, orders, authToken, history]);

  const _rejectOrder = useCallback(async (row, data) => {
    try {
      await axios.patch(
        UpdateOrderAPI(row.code),
        {
          orderAdminStatus: "Rejected",
          orderStatus: "Rejected",
          orderAdminDetails: [...(row.orderAdminDetails || []), data],
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      _getOrders(page, rowsPerPage, searchTerm);
      toast.success("Order rejected successfully.", {
        position: "top-center",
        autoClose: 2000,
        theme: "light",
      });
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error rejecting order:", err);
      }
      toast.error("Failed to reject order. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }, [authToken, _getOrders, page, rowsPerPage, searchTerm]);

  const _onPrintAllOrdersWithCustomerName = useCallback(async () => {
    try {
      await axios.post(
        BulkPrintOrdersAPI(),
        {
          orders: selectedRows,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      // Optimize array operations with Map-based lookup
      const ordersMap = new Map(orders.map(o => [o._id, o]));
      const tmp = selectedRows.map((id) => {
        const o = { ...ordersMap.get(id) };
        if (o) {
          o.printCustomerName = true;
        }
        return o;
      }).filter(Boolean);

      history.push("/admin/order-print", { orders: tmp });
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error printing orders:", e);
      }
      toast.error("Failed to print orders. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }, [selectedRows, orders, authToken, history]);

  const _confirmMultipleOrders = useCallback(async (selectedRows1, data) => {
    try {
      const apiURL = UpdateMultipleOrders();

      const updates = selectedRows1.map((row) => ({
        code: row.code,
        orderCompleted: true,
        orderAdminStatus: "Confirmed",
        orderStatus: "Completed",
      }));

      const res = await axios.patch(
        apiURL,
        { selectedRows: updates },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      _getOrders(page, rowsPerPage, searchTerm);
      setSelectedRows1([]);
      if (res.status === 200) {
        toast.success("Records Updated.", {
          position: "top-center",
          autoClose: 2000,
          theme: "light",
        });
      }
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error updating records:", err);
      }
      toast.error("Failed to update records. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        theme: "light",
      });
    }
  }, [authToken, _getOrders, page, rowsPerPage, searchTerm]);

  const _confirmOrder = useCallback(async (row, data) => {
    try {
      await axios.patch(
        UpdateOrderAPI(row.code),
        {
          orderCompleted: true,
          orderAdminStatus: "Confirmed",
          orderStatus: "Completed",
          orderAdminDetails: [...(row.orderAdminDetails || []), data],
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      _getOrders(page, rowsPerPage, searchTerm);

      // Send WhatsApp Notification
      if (userInfo.phone && row.orderDetails) {
        try {
          await sendWhatsAppMessage(userInfo.phone, row.orderDetails);
        } catch (whatsappErr) {
          if (process.env.NODE_ENV === 'development') {
            console.error("Error sending WhatsApp message:", whatsappErr);
          }
          // Don't fail the order confirmation if WhatsApp fails
        }
      }

      toast.success("Order confirmed successfully.", {
        position: "top-center",
        autoClose: 2000,
        theme: "light",
      });
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error updating order:", err);
      }
      toast.error("Failed to confirm order. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        theme: "light",
      });
    }
  }, [authToken, _getOrders, page, rowsPerPage, searchTerm, userInfo.phone]);

  const OrderTypeDialog = () => {
    return (
      <Dialog
        onClose={() => setOpenOrderTypeDialog(false)}
        aria-labelledby="simple-dialog-title"
        open={openOrderTypeDialog}
      >
        <DialogTitle id="simple-dialog-title">Select Order Type</DialogTitle>
        <List>
          {orderTypes.map((item) => (
            <ListItem
              button
              onClick={() => {
                setSelectedType(item);
                setOpenOrderTypeDialog(false);
                if (item === "Ready") {
                  setOpenReadyOrderAddDialog(true);
                } else if (item === "Fitting") {
                  setOpenFittingOrderAddDialog(true);
                } else {
                  setOpenPrescriptionOrderAddDialog(true);
                }
              }}
              key={item}
            >
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>
      </Dialog>
    );
  };
  const handleOpenConfirmationModal = (object) => {
    setOpenConfirmationModal(object);
  };
  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function closeReadyOrderAddDialog() {
    setOpenReadyOrderAddDialog(false);
  }
  function closeEmailDialog() {
    setOpenEmailDialog(false);
  }
  function closeWhatsAppDialog() {
    setOpenWhatsappDialog(false);
  }

  function closeFittingOrderAddDialog() {
    setOpenFittingOrderAddDialog(false);
  }

  function closePrescriptionOrderAddDialog() {
    setOpenPrescriptionOrderAddDialog(false);
  }

  function closeViewDialog() {
    setOpenViewDialog(null);
  }
  const handleOpenOrderDetailsModal = (object) => {
    setOpenOrderDetailsModal(object);
  };
  const handleCloseOrderDetailsModal = () => {
    setOpenOrderDetailsModal(null);
  };

  const _renderTable = (orderType, data, tabIndex) => {
    // Data is already filtered server-side, use directly
    let filteredData = data;

    // Helper function to preload images
    const preloadImages = (htmlString) => {
      return new Promise((resolve) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        tempDiv.style.position = 'absolute';
        tempDiv.style.left = '-9999px';
        tempDiv.style.top = '-9999px';
        document.body.appendChild(tempDiv);

        const images = tempDiv.querySelectorAll('img');
        if (images.length === 0) {
          document.body.removeChild(tempDiv);
          resolve();
          return;
        }

        let loadedCount = 0;
        const totalImages = images.length;

        images.forEach((img) => {
          const imageLoader = new Image();
          imageLoader.crossOrigin = 'anonymous';
          imageLoader.onload = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
              document.body.removeChild(tempDiv);
              resolve();
            }
          };
          imageLoader.onerror = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
              document.body.removeChild(tempDiv);
              resolve();
            }
          };
          imageLoader.src = img.src;
        });
      });
    };

    const handlePrint = async (row) => {
      let options = {
        orientation: "p",
        unit: "pt",
        format: [284, 800],
        putOnlyUsedFonts: true,
      };
      let htmlTemplate = fxOrderTemplate(row, baseUrl);
      await htmlTemplateToDataString(htmlTemplate, options, (dataString) => {
        const preBlob = dataURItoBlob(dataString);
        window.open(URL.createObjectURL(preBlob, "_blank"));
      });
    };

    const handlePrints = async (rows) => {
      // Continuous print: all orders on one long page (no page breaks)
      const options = {
        orientation: "p",
        unit: "pt",
        format: [284, 800],
        putOnlyUsedFonts: true,
        forceSinglePage: true,
        renderWidthPx: 284,
      };
      const htmlTemplate = fxOrderTemplate(rows, baseUrl);
      await htmlTemplateToDataString(htmlTemplate, options, (dataString) => {
        const preBlob = dataURItoBlob(dataString);
        window.open(URL.createObjectURL(preBlob, "_blank"));
      });
    };

    const handleSearch = () => {
      // Cancel debounce and search immediately
      debouncedSearchRef.current.cancel();
      if (search && search.trim()) {
        searchData(search.trim());
      } else {
        setSearchTerm("");
        setPage(0);
        _getOrders(0, rowsPerPage, "");
      }
    };

    return (
      <GridItem xs={12} sm={12} md={12}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          {orderType === "Prescription" ? (
            <>
              <Button
                color="primary"
                onClick={() =>
                  handleOpenConfirmationModal({
                    msg: "Do you want to print all records",
                    onPress: () => _onPrintAllOrders(),
                  })
                }
              >
                Print All Records
              </Button>
              <Button
                color="primary"
                onClick={() =>
                  handleOpenConfirmationModal({
                    msg: "Do you want to print all records",
                    onPress: () => _onPrintAllOrdersWithCustomerName(),
                  })
                }
              >
                Print All Records With Customer Name
              </Button>
              <Button color="Primary" onClick={() => setOpenEmailDialog(true)}>
                Send as Email
              </Button>
              <Button
                color="Primary"
                onClick={() => setOpenWhatsappDialog(true)}
              >
                Send as WhatsApp
              </Button>
            </>
          ) : (
            <div />
          )}
          <div>
            <CustomInput
              id="search"
              formControlProps={{
                fullWidth: false,
              }}
              inputProps={{
                style: {
                  color: "primary",
                  marginTop: 0,
                },
                placeholder: "Search by code....",
                value: search,
                onChange: (e) => {
                  const value = e.target.value;
                  setSearch(value);
                  // Debounced search
                  debouncedSearchRef.current(value, rowsPerPage, _getOrders);
                },
                onKeyDown: (e) => {
                  if (e.keyCode === 13) {
                    e.preventDefault();
                    // Cancel debounce and search immediately on Enter
                    debouncedSearchRef.current.cancel();
                    handleSearch();
                  }
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      color={"primary"}
                      onClick={handleSearch}
                    >
                      <Search />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <IconButton
              aria-label="add"
              onClick={() => setOpenPrescriptionOrderAddDialog(true)}
            >
              <AddIcon />
            </IconButton>
          </div>
        </Box>
        <Box>
          <div>
            {/* Conditionally render the Confirm button when selectedRows1 is not empty */}
            {selectedRows1.length > 0 && (
              <>
                <Button
                  color="Primary"
                  onClick={() =>
                    handleOpenOrderDetailsModal({
                      title: "Do you want to Accept Multiple Orders?",
                      onPress: (data) =>
                        _confirmMultipleOrders(selectedRows1, data),
                    })
                  }
                >
                  Confirm Selected Orders
                </Button>

                {/* Add the new Print Selected Orders button */}
                <Button
                  color="primary"
                  onClick={() =>
                    handleOpenOrderDetailsModal({
                      title: "Do you want to Print Multiple Orders?",
                      onPress: (data) => handlePrints(selectedRows1, data),
                    })
                  }
                >
                  Print Selected Orders
                </Button>
              </>
            )}

          </div>
        </Box>

        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {orderType === "Prescription" ? (
                <Checkbox
                  style={{
                    color: "#512da8",
                  }}
                  onChange={(e) => {
                    if (e.target.checked) {
                      const c = orders.map((i) => i._id);
                      const d = [...data];
                      setSelectedRows(c);
                      setSelectedRows1(d);
                    } else {
                      setSelectedRows([]);
                      setSelectedRows1([]);
                    }
                  }}
                  checked={
                    selectedRows.length > 0 &&
                    orders.length === selectedRows.length
                  }
                  inputProps={{ "aria-labelledby": -1 }}
                />
              ) : null}
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={"center"}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading
              ? [
                <TableRow key="loader">
                  <TableCell
                    colSpan={
                      columns.length + (orderType === "Prescription" ? 1 : 0)
                    }
                    align="center"
                  >
                    <CircularProgress />
                  </TableCell>
                </TableRow>,
              ]
              : filteredData.length > 0
                ? filteredData.map((row) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.code}
                    >
                      {orderType === "Prescription" ? (
                        <TableCell padding="checkbox">
                          <Checkbox
                            style={{
                              color: "#512da8",
                            }}
                            onChange={() => {
                              // Batch state updates to prevent multiple re-renders
                              let copy = [...selectedRows];
                              let rows = [...selectedRows1];

                              const rowIndex = copy.indexOf(row._id);
                              const rowsIndex = rows.findIndex((r) => r._id === row._id);

                              if (rowIndex !== -1) {
                                copy.splice(rowIndex, 1);
                                if (rowsIndex !== -1) {
                                  rows.splice(rowsIndex, 1);
                                }
                              } else {
                                copy.push(row._id);
                                rows.push(row);
                              }

                              setSelectedRows(copy);
                              setSelectedRows1(rows);
                            }}
                            checked={_.includes(selectedRows, row._id)}
                            inputProps={{ "aria-labelledby": row._id }}
                          />
                        </TableCell>
                      ) : null}
                      {columns.map((column) => {
                        let value = row[column.id];
                        if (column.id === "product") {
                          if (row.orderType === "Fitting") {
                            value =
                              row.orderDetail && row.orderDetail.productName
                                ? row.orderDetail.productName
                                : "";
                          } else if (row.orderType === "Ready") {
                            value =
                              row.orderDetail && row.orderDetail.product
                                ? row.orderDetail.product.name
                                : "";
                          } else {
                            value =
                              row.orderDetail && row.orderDetail.product
                                ? row.orderDetail.product.productName
                                : "";
                          }
                        }
                        if (column.id === "productType") {
                          value = row.orderDetail?.product?.productType || "";
                        }
                        if (column.id === "action") {
                          return (
                            <TableCell align={"center"}>
                              <Box display={"flex"} justifyContent={"center"}>
                                <IconButton
                                  aria-label="view"
                                  onClick={() =>
                                    setOpenViewDialog({
                                      open: true,
                                      item: row,
                                    })
                                  }
                                >
                                  <VisibilityIcon />
                                </IconButton>
                                <IconButton
                                  aria-label="view"
                                  onClick={() => handlePrint(row)}
                                >
                                  <PrintIcon />
                                </IconButton>
                                {row.orderType === "Prescription" &&
                                  row.orderAdminStatus === "Pending" &&
                                  row.isOrderFromApp === true && (
                                    <React.Fragment>
                                      <IconButton
                                        aria-label="confirm"
                                        onClick={() =>
                                          handleOpenOrderDetailsModal({
                                            title:
                                              "Do you want to Accept Order",
                                            onPress: (data) =>
                                              _confirmOrder(row, data),
                                          })
                                        }
                                      >
                                        <CheckCircleIcon />
                                      </IconButton>
                                      <IconButton
                                        aria-label="reject"
                                        onClick={() =>
                                          handleOpenOrderDetailsModal({
                                            title:
                                              "Do you want to Reject Order",
                                            onPress: (data) =>
                                              _rejectOrder(row, data),
                                          })
                                        }
                                      >
                                        <CancelIcon />
                                      </IconButton>
                                    </React.Fragment>
                                  )}
                                {row.orderType === "Prescription" &&
                                  row.orderStatus === "Pending" &&
                                  row.isOrderFromApp === false && (
                                    <React.Fragment>
                                      <IconButton
                                        aria-label="confirm"
                                        onClick={() =>
                                          handleOpenOrderDetailsModal({
                                            title:
                                              "Do you want to Accept Order",
                                            onPress: (data) =>
                                              _confirmOrder(row, data),
                                          })
                                        }
                                      >
                                        <CheckCircleIcon />
                                      </IconButton>
                                      <IconButton
                                        aria-label="reject"
                                        onClick={() =>
                                          handleOpenOrderDetailsModal({
                                            title:
                                              "Do you want to Reject Order",
                                            onPress: (data) =>
                                              _rejectOrder(row, data),
                                          })
                                        }
                                      >
                                        <CancelIcon />
                                      </IconButton>
                                    </React.Fragment>
                                  )}
                                <IconButton
                                  aria-label="delete"
                                  onClick={() =>
                                    handleOpenConfirmationModal({
                                      msg: "Do you want to delete this record?",
                                      title: "Delete Record",
                                      onPress: () => _deleteItem(row),
                                    })
                                  }
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Box>
                            </TableCell>
                          );
                        }

                        if (column.id === "party") {
                          return (
                            <TableCell key={column.id} align={"center"}>
                              {value.accountName}
                            </TableCell>
                          );
                        }
                        return (
                          <TableCell key={column.id} align={"center"}>
                            {column.format ? column.format(value) : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })
                : [
                  <TableRow key="no-records">
                    <TableCell
                      colSpan={
                        columns.length + (orderType === "Prescription" ? 1 : 0)
                      }
                      align="center"
                    >
                      No records found
                    </TableCell>
                  </TableRow>,
                ]}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 25, 100]}
          component="div"
          count={tota}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </GridItem>
    );
  };

  // Data is already filtered server-side, so we can use orders directly
  // No need for client-side filtering since API returns filtered data per tab

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CustomTabs
          title=""
          headerColor="primary"
          value={activeTabIndex}
          onChange={handleTabChange}
          tabs={[
            {
              tabName: "Pending Web",
              tabIcon: Code,
              tabContent: _renderTable(
                "Prescription",
                orders,
                0
              ),
            },
            {
              tabName: "Completed Web",
              tabIcon: Cloud,
              tabContent: _renderTable(
                "Prescription",
                orders,
                1
              ),
            },
            {
              tabName: "Pending App",
              tabIcon: Code,
              tabContent: _renderTable(
                "Prescription",
                orders,
                2
              ),
            },
            {
              tabName: "Completed App",
              tabIcon: Code,
              tabContent: _renderTable(
                "Prescription",
                orders,
                3
              ),
            },
          ]}
        />
      </GridItem>

      <PrescriptionOrderAdd
        fetchData={refreshOrders}
        open={openPrescriptionOrderAddDialog}
        close={closePrescriptionOrderAddDialog}
      />

      <SendEmail
        fetchData={refreshOrders}
        open={openEmailDialog}
        close={closeEmailDialog}
      />
      <SendWhatsApp
        fetchData={refreshOrders}
        open={openWhatsappDialog}
        close={closeWhatsAppDialog}
      />
      <OrderTypeDialog />
      {openViewDialog ? (
        <OrderView
          open={openViewDialog.open}
          close={closeViewDialog}
          item={openViewDialog.item}
        />
      ) : null}
      {openConfirmationModal ? (
        <ConfirmationDialog
          open={openConfirmationModal}
          onClose={handleCloseConfirmationModal}
          onConfirm={openConfirmationModal.onPress}
          title={openConfirmationModal.title}
          msg={openConfirmationModal.msg}
        />
      ) : null}
      {openOrderDetailsModal ? (
        <OrderDetailsDialog
          open={openOrderDetailsModal}
          onClose={handleCloseOrderDetailsModal}
          onConfirm={openOrderDetailsModal.onPress}
          title={openOrderDetailsModal.title}
          msg={openOrderDetailsModal.msg}
          setOrderAdminDetails={setOrderAdminDetails}
          orderAdminDetails={orderAdminDetails}
        />
      ) : null}
    </GridContainer>
  );
}
